import axios from "axios";

export const workorderSearchfilter = async (authtoken, tranId) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/workOrders/search`,
    { tranId: tranId },
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

export const workOrderFilterAll = async (
  authtoken,
  radioData,
  currentPage,
  sortOrder
) => {

  return await axios.post(
    `${process.env.REACT_APP_API}/workOrders/filterData?page=${currentPage}&perPage=10&sortOrder=${sortOrder}`,
    { radioData },
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

export const getWorkOrderCount = async (authtoken) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/workOrders/work-order-count`,
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};
